<template>
	<footer class="el-footer App-footerBg">
		<div class="App-footer">
			<span class="links marl20 cur" @click="officialhome">首页</span>
			<p>版权所有：北京一脉阳光医学信息技术有限公司<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_block" v-html="'&nbsp;&nbsp;&nbsp;&nbsp;京ICP备16038310号-2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'">
					</a> 京B2-20191884 <b>|</b><a href="https://terms.rimagdata.com/rimagcloudprivacypolicy.html">隐私政策</a></p>
			<p class="App-footer-icons"><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038103"
				 target="_block"> 京公网安备11010502038103号</a></p>
		</div>
	</footer>
</template>
<script>
export default {
	methods: {
		officialhome() {
			window.location.href = "https://www.rimagdata.com/";
		}
	}
}
</script>
<style lang="scss" scoped="scoped">
	@import '@/assets/style/variables.scss';
	@import "@/assets/style/mixin.scss";
	.App-footer-icons {
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAACUlBMVEUAAADe/962i1DdvXrmyojGo2PhuZHCo1zEpnLfxom3k1rTwnvQrGS9n2nf0I/g05mSttzOqE3o0ovRtHG3VjHAb0HHrHjIp2DKfUnVu3HLsHLHq3Hfy47ZwYe8m2G1lWLPs3XKr3K+o2/Jr3/OqmrhyI3tz4a9jE/FpWvSpmHNr2fRs3TUtnjkz4HXvHfAoV7St3W9jk/Utn/l0IXgz4rFrWq7mFm8m2fLtoC7mFrKp2rTt3rb247Co3q1lWDYxInhIhvHrHTIrm/Xh1Gxgj2+SyvYOybcHRjUFxPZwofexnG8n2/ApG28oW23m2jQsmbPsV/BoF3dvVzMrFm5lFTPrFLgfErgXjvFZTrRYDm5YjXDWDXYVDXOTy60Ui21TSvbOyrcQim1WyfZNSaxRSTJNSG2MR6yLh7iHhrTIBjfGRjXxZnNtoTWvoDHr4Dg0HnWv3nDp3fDq3PXv3LXum/axm3JrWzDqWy6nmbFq2Xhl2S1lWLStWDUmF++nFzJp1u1lVvmi1vXklnGolbGoFbawFPNmFO/n1LqblHFl1DOh1DJkU+2kU+wh0zGmkrIfkrHg0m3kEjPfkjNeUeugkTBfUPoaUO9kEKkfELcYkHWtD+9iDvEYjjZXDi3gzemdTfFbjbKZTbFWjXLWTXOVjXDVzO5XDLVUzKoXTHlTTDgQy6iVi2yVC27XivCSyvKTCq7SinjQCnRNievRCaxSyXBOyXUMyTcNCPnMyPDQSLXNiLQNiLaMyK6MiDTLSDjKh7cJxzdIhvXHxjkHBjaHBfWFRN2Gm/TAAAAQHRSTlMAB40nHhwG/rh3dmRfRTsUA/79/f37+vn18/Ls6urp5OPh4d3b0snFurqvrKGgn56OjomIa2phXFRSOi4rGRgNXJsWNAAAAUBJREFUGNNigAJGbhNGEA3n85mqi0RoctvARQT0RF3XbXCNXCxhDBWx0pp8KKx/6aKuRgdnXWuQCL9KrMfM2m1uCfuaOtynqYFMtPDf7eEcczA52WF5VcYqIT4GBjb90PUek8LdN8c7zHXOCvcyEGBglixdeDS2O271imVtMVlh+TIsDMxSlVMzM6Mj1kTNWeLgMMFJlgUwBhbpkOmp7qmucVHRmw4nTvRV5GfQYfesWXvkwK6E7Xv2ZywIyBXnZDBydCwR3Lkj0c1t48rI0OAiT04GViU/p+LOlL3paVvj+7zK8xRYGRjMxHJCCmanpKdtmRccmC3Mw8DAq+zj61MWNCspqTWIvcLPSZWZwZaj0Lu6riXAv725PrDB21HbHuh8cw75GfNdeqe4uPTIafCwQcLCjpeLicmQicuSFcQDAF2FXflf7Dj/AAAAAElFTkSuQmCC);
		background-position: left;
	}

	.App-footer-icons a {
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAACXlBMVEUAAADax4rGxqP556zmsVD/6KXu5JvwvFPglEFnY3nnpEjosU1+XFTmuVfu13Hrv1jpsFa1k3mne2HlvnPdqmPqz3fu3YrJoWv04J/mz5z246aSi3i2p2/0zGj82WDrtFjar1O7klO4dkfimUJcWnbho0rgr1vntFfmvFflvGOZdFKXZkOUemnmv2XkuWWVe2ziqlXnt1Tr0HDpwl6ObmCkbEKqhVyOc2jdoVHmuljfrmDq0nPapWDUnErqy3XjtWXesXLrzHjz34rqzYfmw3fy4YrqyYDevW/dzoTIhkndsXLRsIneuHjlyIzQroTjuXjlyYfktWvw2prhvoHTmGfx45j3773TuYT/25LdijyKf321oXU+Nm3cumXfuWLtwlzpwVz40FvpvlvqvFfouFXjrlHipEjcmEfknEXPbzfbZyzZQR/YMBrWKBrhJhLdHxDTGg5HV4xBT4YYKYaWk4SDgYIWIYBybH0qLn1KS3tlZHpNS3WGfHIcHXEwLHAnF28rKW07NGuzn2pNQ2ruzWnDrGnuy2jryGjAnGgoH2j1x2RCNGPcrmIsEGGQdl/pu17YtV7FoV3muVxoRVzWqFvSmVp2SVbyw1XbkVTuvFPfo1PgmVPpt1LcnFLWkVLlp1F7W1HpsU92QE5oMUtFAUrpqUjnjUFOAEHUgz+DUj14FzvbczieMTdhATfodjXWcDXcbjXVcTS/Xi/hay7WXS3cWS3vYyvaVSrUVymnJSjXSyeKDSbNSiWfHCPMTyLFQiHkSR/lPxvVLRrPLBnUJRfUHhbaJxXVGxTZJxPNFhBdOhm/AAAAWXRSTlMABQIU/hIJ/v79/Pj29PPx4cC6s7CNfmxZWRv+/v7+/v7+/v78/Pr6+fPz8vHq6ujl5eTj4ODe2NTQzMW6ubKsnJeQkJCJiIOBgX9ubGpoW1lMREM0JR8dDgvYx1gAAAE7SURBVBjTYgADJmZJQUFJZiYGOGD2EzLV1jIT8paCibCJ86zctGPD1D4ecUaICKuPyYLMYznZOfNqzP0jwEJBOt1KB4/mHjqZ3dGsHwxW5M4Zk5l/PPdIQcGMShUPVqBlgQLlMSvyDq+P3HVidjWnkQQTA5MXV1SFYtb+jZGrl02si2J3Y2JgFMmILl68efueLVvXLSqLXirCCBgDow1HT+GS/AP7srblLS+K5bIHCjmodpXUr929d+eaVb3SsuouQCHhufPjShsbJk/rrK2KW8hiBxRyVkvnkI9tnaDQJDNFOU1DDOjRMEfe9Mjpiewz5RIzZmmKMoPcKqGbkJqSkBSfnDqpXS+ACeRpJ76W/uSUpDlpLPFtfK5soLAKFbU05Odm4eblN7YWk4KEGWOIp62FgYCVsG84SAAAL7BaooX965sAAAAASUVORK5CYII=);
		background-position: left;
		display: inline-block;
	}
	@media screen and (min-width: 750px) {
		.App-footerBg {
			width: 100%;
			height: 60px;
			background: #2a2a2a;
		}

		.App-footer {
			width: 1200px;
			margin: 0 auto;
			height: 60px;
			display: -webkit-flex;
			display: flex;
			-webkit-align-items: center;
			align-items: center;
			-webkit-justify-content: space-between;
			justify-content: space-between;
		}

		.App-footer p {
			color: #9d9d9d;
			font-size: 12px;
		}

		.App-footer p a {
			@include text-color(fzColor);
		}

		.App-footer p b {
			color: #4e4e4e;
			margin: 0 25px;
		}

		.App-footer p {
			color: #9d9d9d;
			font-size: 12px;
		}

		.App-footer-icons,
		.App-footer-icons a {
			background-repeat: no-repeat;
			background-size: 18px 18px;
		}

		.App-footer-icons {
			text-indent: 30px;
		}
		
		.App-footer p a:hover{
			color: #3291f1;
		}
	}

	@media screen and (max-width: 750px) {

		.App-footer {
			width: 96%;
			margin: 8px auto;
		}

		.App-footer p {
			color: #9d9d9d;
			font-size: 8px;
		}

		.App-footer p a {
			@include text-color(fzColor);
			font-size: 8px;
		}

		.App-footer-icons,
		.App-footer-icons a {
			background-repeat: no-repeat;
			background-size: 12.4px 12.4px;
			padding-left: 14.4px;
		}
		.App-footer p b {
			color: #4e4e4e;
			margin: 0 4px;
		}
		.login-wrap .el-footer{
			display: unset;
			text-align: left;
			height: auto !important;
			background-color: #1d1d1d;
			box-sizing: border-box;
			font-size:12px !important;
			line-height: inherit !important;
		}
	}
</style>
